import { render, staticRenderFns } from "./GroupSize.vue?vue&type=template&id=ba09391e&"
import script from "./GroupSize.vue?vue&type=script&lang=js&"
export * from "./GroupSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba09391e')) {
      api.createRecord('ba09391e', component.options)
    } else {
      api.reload('ba09391e', component.options)
    }
    module.hot.accept("./GroupSize.vue?vue&type=template&id=ba09391e&", function () {
      api.rerender('ba09391e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/GroupSize.vue"
export default component.exports